import { BottomNavigation, Divider, SwipeableDrawer } from '@mui/material';
import styled from 'styled-components';

// Pinned bottom bar. A flex child of the content column (not fixed), so content
// scrolls above it and it stays put. Icon-only actions; the active one (or
// "More", when the current page lives inside the sheet) takes the brand colour.
const StyledBottomNavigation = styled(BottomNavigation)`
  && {
    flex-shrink: 0;
    /* Keep the action row at appbarHeight, then reserve the device safe-area
       inset below it so the bar clears the home indicator / browser chrome. */
    height: calc(${({ theme }) => theme.shape.appbarHeight}px + env(safe-area-inset-bottom, 0px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    background-color: ${({ theme }) => theme.palette.background.default};
    border-top: 1px solid ${({ theme }) => theme.palette.divider};

    & .MuiBottomNavigationAction-root {
      min-width: 0;
      margin: ${({ theme }) => theme.spacing(0.5)};
      padding: ${({ theme }) => theme.spacing(0.5)};
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
      color: ${({ theme }) => theme.palette.gray.main};
      transition: ${({ theme }) =>
        theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
        })};
      &:hover {
        background-color: ${({ theme }) => theme.palette.action.hover};
      }
    }
    /* Selection is communicated by colour only — hold the label size constant so
       the active tab neither grows (MUI's default) nor bolds, matching the rest
       of the app's selected-state styling. */
    & .MuiBottomNavigationAction-label {
      margin-top: ${({ theme }) => theme.spacing(0.5)};
      font-size: 0.6875rem;
      &.Mui-selected {
        font-size: 0.6875rem;
      }
    }
    & .Mui-selected {
      color: ${({ theme }) => theme.palette.primary.dark};
    }
  }
`;

// Full-width sheet rising from the bottom. Rounded top corners and a column
// layout so the puller stays pinned while the nav list scrolls beneath it.
const StyledSwipeableDrawer = styled(SwipeableDrawer)`
  && {
    & .MuiDrawer-paper {
      background-color: ${({ theme }) => theme.palette.background.default};
      background-image: none;
      border-top-left-radius: ${({ theme }) => theme.spacing(2)};
      border-top-right-radius: ${({ theme }) => theme.spacing(2)};
      max-height: 85vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  }
`;

// Drag handle. The whole sheet is swipeable to dismiss, but the puller is the
// obvious grab target and reads as draggable.
const Puller = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.backdrop.dark};
  margin: ${({ theme }) => theme.spacing(1.5)} auto ${({ theme }) => theme.spacing(1)};
  cursor: grab;
`;

const SheetScroll = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const SheetFooterDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
    border-color: ${({ theme }) => theme.palette.divider};
  }
`;

export { Puller, SheetFooterDivider, SheetScroll, StyledBottomNavigation, StyledSwipeableDrawer };
